import { IMainMenuNode } from 'state/unified-menu/types';
import { routes } from 'utils/routing';

export const buildMenuLink = (item: IMainMenuNode) => {
  return `${routes.menu}/${item.type.toLowerCase()}/${item.id}`;
};
